<template>
  <div>
    <div class="header" id="header">
      <div @click="back" class="back">
        <i class="iconfont">&#xe604;</i>
      </div>
      <div class="search">
        <div class="search-box">
          <i class="iconfont">&#xe706;</i>
          <input type="text" placeholder="请输入您要搜索的商品" v-model="keyword">
        </div>
      </div>
      <div class="search-font">
        <button type="submit" @click="handleSearchClick">{{state}}</button>
      </div>
    </div>
    <div class="content" id="hot">
      <div class="hot">
        <p>热门搜索</p>
      </div>
      <div class="hot-search">
        <div v-for="(item, index) in slist" :key="index" @click="handleHotSearchClick(index)">{{item.desc}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultHeader',
  props: {
    slist: Array
  },
  data () {
    return {
      state: '搜索',
      keyword: ''
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handleSearchClick () {
      this.$router.push({
        path: '/search_result',
        query: {
          keyword: this.keyword
        }
      })
    },
    handleHotSearchClick (index, res) {
      var hotkeyword = this.slist[index].desc
      this.$router.push({
        path: '/search_result',
        query: {
          keyword: hotkeyword
        }
      })
      // console.log(hotkeyword)
      // this.keyword = hotkeyword
    }
  }
}
</script>

<style scoped>
.header{ display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f2f2f2; padding: 10px 15px;}
.back a{ text-decoration: none; color: #333;}
.back .iconfont{ font-size: 25px;}
.search-font button{ color: #9f9e9e; border: 0; background: transparent; font-family: Arial,"Microsoft YaHei";}
.search-box{ display: flex; justify-content: space-around; background-color: #efefef; border-radius: 3px;}
.search input{ width: 240px; border: 0; border-radius: 3px; background-color: #efefef;}
input::-webkit-input-placeholder{ color:#7f7f7f; font-size: 13px; line-height: 15px; font-family: Arial,"Microsoft YaHei";}
.search .iconfont{ line-height: 32px; margin: 0 8px; font-size: 14px;}
.back{ width: 7%;}
.search{ width: 78%;}
.search-font{ width: 9%;}
.content{ padding: 10px 15px; padding-bottom: 0;}
.hot{ display: flex; justify-content: space-between; align-items: center;}
.hot p{ font-size: 13px; color: #b6b6b6;}
.hot .iconfont{ font-size: 20px; color: #b6b6b6;}
.hot-search{ display: flex; flex-wrap: wrap; padding-top: 10px;}
.hot-search div{ background-color: #f0f0f0; padding: 5px 10px; border-radius: 3px; margin: 5px; margin-top: 0; font-size: 13px;}
</style>



// WEBPACK FOOTER //
// src/pages/search/components/Header.vue